// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gg-0";
export var actionModalContentContainer = "_gg-1";
export var createTagButton = "_gg-2";
export var footerContainer = "_gg-7";
export var fullWidthDivider = "_gg-3";
export var hasCreateTagButton = "_gg-4";
export var noCreateTagButton = "_gg-5";
export var tagsContainer = "_gg-6";
export var tagsModalContentContainer = "_gg-8";